import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(`
  <div>
    <h3>***RESOLUTION SOP FOR IN_QC_LATE_MID_BLOCK_CHECKIN***</h3>
    <ol>
      <li>Check if DP is available at site premises.
        <ol>
          <li>No → Move to step 2</li>
          <li>Yes → Move to step 3</li>
        </ol>
      </li>
      <li>LM POC calls DP. Check if DP answers call.
        <ol>
          <li>Yes → Move to step 3</li>
          <li>No → Snooze exception for 10min.</li>
          <ol>
            <li>Note: Assuming we will have discharge enabled for this use case in future. Return to step 1.</li>
          </ol>
        </ol>
      </li>
      <li>LM POC will talk to DP to identify reason.</li>
      <li>Check if DP is willing to continue with block.
        <ol>
          <li>No → Discharge and raise capacity to CO</li>
          <li>Yes → Move to step 5</li>
        </ol>
      </li>
      <li>Close exception with reason for delay.</li>
    </ol>
    <p>For more details, please visit: <a href="https://w.amazon.com/bin/view/Stratos/Internal/MBEDashboard/ExceptionSOP/IN_QC_LATE_MID_BLOCK_CHECKIN/">Wiki</a></p>
  </div>
`);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/IN_QC_LATE_MID_BLOCK_CHECKIN.jsx